export const Activity = {
  price: 0,
  currency: 'USD',
  description: '',
  startDate: '',
  endDate: '',
  defaultPhotoId: '',
  contentPOIs: [{}]
}

export const Lodging = {
  price: 0,
  currency: 'USD',
  description: '',
  startDate: '',
  endDate: '',
  defaultPhotoId: '',
  contentPOIs: [{}],
  eventDetails: {
    bookedThrough: '',
    confirmationCode: ''
  }
}

export const Flight = {
  price: 0,
  currency: 'USD',
  description: '',
  startDate: '',
  endDate: '',
  defaultPhotoId: '',
  contentPOIs: [{}],
  eventDetails: {
    bookedThrough: '',
    confirmationCode: '',
    flightDetails: {
      airline: '',
      flightNumber: '',
      terminal: '',
      gateNumber: '',
      departureAirport: {
        code: `${Math.random()}`,
        apiId: '',
        name: ''
      },
      arrivalAirport: {
        code: `${Math.random()}`,
        apiId: '',
        name: ''
      }
    }
  }
}

export const CarRental = {
  price: 0,
  currency: 'USD',
  description: '',
  startDate: '',
  endDate: '',
  defaultPhotoId: '',
  contentPOIs: [{}],
  eventDetails: {
    bookedThrough: '',
    confirmationCode: '',
    transportationDetails: {
      departure: '',
      arrival: '',
      carrier: ''
    }
  }
}

export const Train = {
  price: 0,
  currency: 'USD',
  description: '',
  startDate: '',
  endDate: '',
  defaultPhotoId: '',
  contentPOIs: [{}],
  eventDetails: {
    bookedThrough: '',
    confirmationCode: '',
    transportationDetails: {
      departure: '',
      arrival: '',
      carrier: ''
    }
  }
}

export const Transportation = {
  price: 0,
  currency: 'USD',
  description: '',
  startDate: '',
  endDate: '',
  defaultPhotoId: '',
  contentPOIs: [{}],
  eventDetails: {
    bookedThrough: '',
    confirmationCode: '',
    transportationDetails: {
      departure: '',
      arrival: '',
      carrier: ''
    }
  }
}

export const Info = {
  startDate: '',
  endDate: '',
  description: '',
  defaultPhotoId: '',
  contentPOIs: [{}]
}



// WEBPACK FOOTER //
// src/components/Event/DefaultForms.js